export const STORAGE_KEY = 'jwtToken'
export const STRIPE_KEY = process.env.NODE_ENV === 'production' ? 'pk_live_WLVO64GrvCvvSbfZINctu0iY00OVWJUISm' : 'pk_test_ecD4GTAsL41IdKoAlGHun7b900pMdmRKYQ'
